var render, staticRenderFns
import script from "./UnitDetailListMixin.vue?vue&type=script&lang=ts&"
export * from "./UnitDetailListMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d743f01')) {
      api.createRecord('4d743f01', component.options)
    } else {
      api.reload('4d743f01', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/UnitDetailListMixin.vue"
export default component.exports